import { isJsonString } from '@js/globalFunctions/isJsonString'
import {pageHasMainSearchBlock} from "../../../../../entrypoints/blocks/search/pageHasMainSearchBlock";

export function applyPregenSearchParameters( searchParamInput )
{
	if (window.location.href.indexOf("filter=1&") === -1)
	{
		searchParamInput = (typeof searchParamInput !== 'undefined') ? searchParamInput : searchParams;
		if (pageHasMainSearchBlock() === false && searchParamInput !== '' && siteTmpl !== 'tmpl-faner-page' && isJsonString(searchParamInput))
		{
			const params = JSON.parse(searchParamInput);
			if (typeof params !== 'undefined' && params !== false && params.length !== 0)
			{
				const acceptedSearchParameters = determineViableSearchParamsFromSearchbox();
				const specialCases = {
					'150': {key: 'husdyr', value: '1'},
					'203': {key: 'skiftedag', value: '2'},
					'204': {key: 'skiftedag', value: '1'},
					'247': {key: 'skiftedag', value: '3'},
					'275': {key: 'skiftedag', value: '4'},
					'281': {key: 'skiftedag', value: '5'},
					'esFreeClean': {key: '201', value: 'True'},
					'fiskeri': {key: 'fiskeri', value: 'True'},
					'outdoorPlay': {key: 'outdoorPlay', value: 'True'},
					'outdoorSpa': {key: '137', value: 'True'},
					'vildmarksbad': {key: '288', value: 'True'},
					'renovatedWithin3Years': {key: 'renovatedWithin3Years', value: 'True'},
					'spabad': {key: '136', value: 'True'},
					'nyHosEsmark': {key: 'nyHosEsmark', value: 'True'},
					'onlyImages': {key: 'onlyImages', value: 'True'},
					'westerland': {key: 'westerland', value: 'True'},
					'nyHus': {key: 'nyHus', value: 'True'},
				};
				const parsedParams = {};
				let empty = false;
				let defaultFacilities = false;
				Object.keys(params).forEach(function (key, index)
				{
					if (key === 'none' || key === 'lastMinute')
					{
						empty = true;
					}
					else if (key === 'specifik_personer')
					{
						parsedParams['156'] = params[key];
					}
					else if (acceptedSearchParameters.indexOf(key) !== -1)
					{
						parsedParams[key] = params[key];
					}
					else if (typeof specialCases[key] !== 'undefined')
					{
						parsedParams[specialCases[key]['key']] = specialCases[key]['value'];
					}
					else
					{
						if (defaultFacilities === false && $('#searcharea').length > 0)
						{
							var attribute = $('#searcharea').attr('data-facilitynames');
							if (isJsonString(attribute))
							{
								defaultFacilities = JSON.parse(attribute);
							}
						}

						if (defaultFacilities !== false)
						{
							if (typeof defaultFacilities[key] !== 'undefined')
							{
								parsedParams[key] = params[key];
							}
						}
					}
				});
				if (empty === true || parsedParams.length === 0)
				{
					searchParameters.clearParameters()
				}
				else
				{
					Object.entries(parsedParams).forEach(([key,value]) => {
						searchParameters.setParameter(key,value);
					})
				}
			}
		}
	}
}

function determineViableSearchParamsFromSearchbox()
{
	if( $('#frontAdvancedSearch').length !== 0 )
	{
		const elements 	= $('.searchValue');
		const names 	= [];
		for( let i = 0; i < elements.length; i++ )
		{
			names.push( $(elements[i]).attr('name') );
		}
		return names;
	}
	return false;
}
